<template>
    <div>

        <div class="form-row">
            <div class="col col-12 col-md-6">
                <az-periodo
                    :sync="true" 
                    @sync="load()"
                    v-model="filtro" />
            </div>
            <div class="col col-12 col-md-6">
                <az-input 
                    placeholder="Informe o nome ou CPF do paciente..."
                    icon="fas fa-user"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="pacientes.index"
                    optionsDisplay="search"
                    ref="info_paciente"
                    v-model="filtro.paciente" 
                    :optimized_ac="true">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="filtro && filtro.paciente">
                            <button type="button" class="btn btn-outline-primary" @click="$root.perfil(filtro.paciente);">
                                <i class="fa fa-id-badge" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>

        <template v-if="dados && dados.movs && dados.movs.length">
            <div class="form-row mt-3">
                <div class="col col-12 col-md-3">
                    <div class="card h-100 mb-0 dashcard">
                        <div class="card-body d-flex justify-content-between py-2" :class="'alert-dark'">
                            <div>
                                <div class="lead">
                                    Total
                                </div>
                                <div class="small font-italic">
                                    Materiais: {{ distintos(dados.movs, 'id_estoque_item') }}
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="display-4">
                                    {{ totalizar(dados.movs, 'in_quantidade') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col col-12 col-md-3">
                    <div class="card h-100 mb-0 dashcard">
                        <div class="card-body d-flex justify-content-between alert-success py-2">
                            <div>
                                <div class="lead">
                                    Usado
                                </div>
                                <div class="small font-italic">
                                    Materiais: {{ distintos(dados.movs.filter(mov => mov.js_uso && mov.js_uso.in_usado > 0), 'id_estoque_item') }}
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="display-4">
                                    {{ totalizar(dados.movs, 'js_uso.in_usado') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col col-12 col-md-3">
                    <div class="card h-100 mb-0 dashcard">
                        <div class="card-body d-flex justify-content-between alert-warning py-2">
                            <div>
                                <div class="lead">
                                    Devolução
                                </div>
                                <div class="small font-italic">
                                    Materiais: {{ distintos(dados.movs.filter(mov => mov.js_uso && mov.js_uso.in_para_devolucao > 0), 'id_estoque_item') }}
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="display-4">
                                    {{ totalizar(dados.movs, 'js_uso.in_para_devolucao') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col col-12 col-md-3">
                    <div class="card h-100 mb-0 dashcard">
                        <div class="card-body d-flex justify-content-between alert-danger py-2">
                            <div>
                                <div class="lead">
                                    Pendente
                                </div>
                                <div class="small font-italic">
                                    Materiais: {{ distintos(dados.movs.filter(mov => mov.js_uso && ( mov.in_quantidade - mov.js_uso.in_usado - mov.js_uso.in_para_devolucao ) > 0), 'id_estoque_item') }}
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="display-4">
                                    {{ total_pendentes(dados.movs) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3">
                <selecao-material 
                    :barcode_only="true" 
                    @selecionado="selecionar_por_bipagem" />
            </div>

            <table class="table table-hover bg-white table-sm mt-2">
                <thead>
                    <tr>
                        <th>Material</th>
                        <th>Lote</th>
                        <th>Solic</th>
                        <th class="text-right">Qtde</th>
                        <th class="text-right">Usado</th>
                        <th class="text-right">Para Devolução</th>
                        <th class="text-right">Pendente</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="mov in dados.movs" :key="mov.id_estoque_item">
                        <td>{{ mov.item.search }} <span class="badge badge-secondary ml-1">#{{ mov.id_estoque_item }}</span></td>
                        <td><template v-if="mov.st_lote != 'Sem Lote'">{{ mov.st_lote }}</template></td>
                        <td>{{ mov.st_doc }}</td>
                        <td class="text-right">{{ mov.in_quantidade }}</td>
                        <td class="text-right">{{ mov.js_uso.in_usado }}</td>
                        <td class="text-right">{{ mov.js_uso.in_para_devolucao }}</td>
                        <td class="text-right">{{ mov.js_uso.in_pendente }}</td>
                    </tr>
                </tbody>
            </table>

            <pre>pend: {{ total_pendentes(dados.movs) }}</pre>

        </template>

        <pre>{{ dados }}</pre>

    </div>

</template>

<script>
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';

export default {
    data() {
        return { 
            filtro: { 
                periodo: "do", 
                paciente: "", 
            },
            dados: null, 
        }
    },

    props: ['suprimentos'], 

    components: { 
        AzPeriodo,
        AzInput,
        SelecaoMaterial,
    },

    methods: { 
        selecionar_por_bipagem(item) { 
            if ( item && item.id_estoque_item ) { 
                let mov = this.dados.movs.find(m => m.id_estoque_item == item.id_estoque_item);
                if ( mov ) { 
                    mov.js_uso.in_usado++;

                    this.$toast.add({ 
                        severity: 'success',
                        summary: 'Uso confirmado',
                        detail: `Material #${item.id_estoque_item} usado: \n${item.search}`,
                        life: 3000
                    });
                }
            }
        },

        distintos (lista, campo) { 
            return _.uniqBy(lista, campo).length;
        },

        totalizar (lista, campo) { 
            return _.sumBy(lista, campo);
        },

        total_pendentes (lista) { 
            return lista.reduce((acc, mov) => {
                if ( !mov.js_uso ) { 
                    return acc; 
                }
                return acc + (mov.in_quantidade - mov.js_uso.in_usado - mov.js_uso.in_para_devolucao);
            }, 0);
        },

        load() { 
            this.$util.load(this, { 
                service: 'estoque',
                func: 'carregar_consumo',
                parms: { 
                    ...this.filtro,
                },
                loadTo: res => { 
                    this.dados = { movs: res.movs.map(mov => { 
                            mov.js_uso = { 
                                in_usado: 0,
                                in_para_devolucao: 0,
                                in_pendente: 0,
                            }

                            return mov;
                        }) 
                    };
                }
            });
        }
    },

    mounted() {
        if ( this.suprimentos ) { 
            //
        } else { 
            this.$store.commit("setBreadcrumb", [
                { name: "Assistência", path: "/assistencia/atend" },
                { name: "Checagem Consumo", path: "/assistencia/checagem-consumo" },
            ]);
        }
    }
}
</script>
